import { ISelectLabel } from "@ds/ds-snam/dist/models/select";

const myStatesArray = [
    "+39", "+30", "+31", "+32", "+33", "+34", "+36", "+37", "+38", 
    "+41", "+42", "+43", "+44", "+45", "+46", "+47", "+48", "+49", 
    "+351", "+353", "+356", "+357", "+358", "+361", "+370", "+371", 
    "+372", "+373", "+374", "+375", "+377", "+378", "+380", "+381", 
    "+382", "+386", "+420", "+421", "+423"
];
export const myCountryArraySelect:ISelectLabel[]=[
    { id: "IT", label: "Italia", value: "IT", selected: false },
    { id: "AL", label: "Albania", value: "AL", selected: false },
    { id: "AD", label: "Andorra", value: "AD", selected: false },
    { id: "AM", label: "Armenia", value: "AM", selected: false },
    { id: "AT", label: "Austria", value: "AT", selected: false },
    { id: "AZ", label: "Azerbaigian", value: "AZ", selected: false },
    { id: "BE", label: "Belgio", value: "BE", selected: false },
    { id: "BY", label: "Bielorussia", value: "BY", selected: false },
    { id: "BA", label: "Bosnia ed Erzegovina", value: "BA", selected: false },
    { id: "BG", label: "Bulgaria", value: "BG", selected: false },
    { id: "VA", label: "Città del Vaticano", value: "VA", selected: false },
    { id: "CY", label: "Cipro", value: "CY", selected: false },
    { id: "HR", label: "Croazia", value: "HR", selected: false },
    { id: "DK", label: "Danimarca", value: "DK", selected: false },
    { id: "EE", label: "Estonia", value: "EE", selected: false },
    { id: "FI", label: "Finlandia", value: "FI", selected: false },
    { id: "FR", label: "Francia", value: "FR", selected: false },
    { id: "DE", label: "Germania", value: "DE", selected: false },
    { id: "GE", label: "Georgia", value: "GE", selected: false },
    { id: "GR", label: "Grecia", value: "GR", selected: false },
    { id: "IE", label: "Irlanda", value: "IE", selected: false },
    { id: "IS", label: "Islanda", value: "IS", selected: false },
    { id: "KZ", label: "Kazakistan", value: "KZ", selected: false },
    { id: "XK", label: "Kosovo", value: "XK", selected: false },
    { id: "LV", label: "Lettonia", value: "LV", selected: false },
    { id: "LI", label: "Liechtenstein", value: "LI", selected: false },
    { id: "LT", label: "Lituania", value: "LT", selected: false },
    { id: "LU", label: "Lussemburgo", value: "LU", selected: false },
    { id: "MK", label: "Macedonia del Nord", value: "MK", selected: false },
    { id: "MT", label: "Malta", value: "MT", selected: false },
    { id: "MD", label: "Moldavia", value: "MD", selected: false },
    { id: "MC", label: "Monaco", value: "MC", selected: false },
    { id: "ME", label: "Montenegro", value: "ME", selected: false },
    { id: "NO", label: "Norvegia", value: "NO", selected: false },
    { id: "NL", label: "Paesi Bassi", value: "NL", selected: false },
    { id: "PL", label: "Polonia", value: "PL", selected: false },
    { id: "PT", label: "Portogallo", value: "PT", selected: false },
    { id: "GB", label: "Regno Unito", value: "GB", selected: false },
    { id: "CZ", label: "Repubblica Ceca", value: "CZ", selected: false },
    { id: "RO", label: "Romania", value: "RO", selected: false },
    { id: "RU", label: "Russia", value: "RU", selected: false },
    { id: "SM", label: "San Marino", value: "SM", selected: false },
    { id: "RS", label: "Serbia", value: "RS", selected: false },
    { id: "SK", label: "Slovacchia", value: "SK", selected: false },
    { id: "SI", label: "Slovenia", value: "SI", selected: false },
    { id: "ES", label: "Spagna", value: "ES", selected: false },
    { id: "SE", label: "Svezia", value: "SE", selected: false },
    { id: "CH", label: "Svizzera", value: "CH", selected: false },
    { id: "TR", label: "Turchia", value: "TR", selected: false },
    { id: "UA", label: "Ucraina", value: "UA", selected: false },
    { id: "HU", label: "Ungheria", value: "HU", selected: false }
]
export const myCountryArraySelectEN:ISelectLabel[]=[
  { id: "IT", label: "Italy", value: "IT", selected: false },
  { id: "AL", label: "Albania", value: "AL", selected: false },
  { id: "AD", label: "Andorra", value: "AD", selected: false },
  { id: "AM", label: "Armenia", value: "AM", selected: false },
  { id: "AT", label: "Austria", value: "AT", selected: false },
  { id: "AZ", label: "Azerbaijan", value: "AZ", selected: false },
  { id: "BY", label: "Belarus", value: "BY", selected: false },
  { id: "BE", label: "Belgium", value: "BE", selected: false },
  { id: "BA", label: "Bosnia and Herzegovina", value: "BA", selected: false },
  { id: "BG", label: "Bulgaria", value: "BG", selected: false },
  { id: "HR", label: "Croatia", value: "HR", selected: false },
  { id: "CY", label: "Cyprus", value: "CY", selected: false },
  { id: "CZ", label: "Czech Republic", value: "CZ", selected: false },
  { id: "DK", label: "Denmark", value: "DK", selected: false },
  { id: "EE", label: "Estonia", value: "EE", selected: false },
  { id: "FI", label: "Finland", value: "FI", selected: false },
  { id: "FR", label: "France", value: "FR", selected: false },
  { id: "GE", label: "Georgia", value: "GE", selected: false },
  { id: "DE", label: "Germany", value: "DE", selected: false },
  { id: "GR", label: "Greece", value: "GR", selected: false },
  { id: "HU", label: "Hungary", value: "HU", selected: false },
  { id: "IS", label: "Iceland", value: "IS", selected: false },
  { id: "IE", label: "Ireland", value: "IE", selected: false },
  { id: "KZ", label: "Kazakhstan", value: "KZ", selected: false },
  { id: "XK", label: "Kosovo", value: "XK", selected: false },
  { id: "LV", label: "Latvia", value: "LV", selected: false },
  { id: "LI", label: "Liechtenstein", value: "LI", selected: false },
  { id: "LT", label: "Lithuania", value: "LT", selected: false },
  { id: "LU", label: "Luxembourg", value: "LU", selected: false },
  { id: "MT", label: "Malta", value: "MT", selected: false },
  { id: "MD", label: "Moldova", value: "MD", selected: false },
  { id: "MC", label: "Monaco", value: "MC", selected: false },
  { id: "ME", label: "Montenegro", value: "ME", selected: false },
  { id: "NL", label: "Netherlands", value: "NL", selected: false },
  { id: "MK", label: "North Macedonia", value: "MK", selected: false },
  { id: "NO", label: "Norway", value: "NO", selected: false },
  { id: "PL", label: "Poland", value: "PL", selected: false },
  { id: "PT", label: "Portugal", value: "PT", selected: false },
  { id: "RO", label: "Romania", value: "RO", selected: false },
  { id: "RU", label: "Russia", value: "RU", selected: false },
  { id: "SM", label: "San Marino", value: "SM", selected: false },
  { id: "RS", label: "Serbia", value: "RS", selected: false },
  { id: "SK", label: "Slovakia", value: "SK", selected: false },
  { id: "SI", label: "Slovenia", value: "SI", selected: false },
  { id: "ES", label: "Spain", value: "ES", selected: false },
  { id: "SE", label: "Sweden", value: "SE", selected: false },
  { id: "CH", label: "Switzerland", value: "CH", selected: false },
  { id: "TR", label: "Turkey", value: "TR", selected: false },
  { id: "UA", label: "Ukraine", value: "UA", selected: false },
  { id: "GB", label: "United Kingdom", value: "GB", selected: false },
  { id: "VA", label: "Vatican City", value: "VA", selected: false }
]
export const provinceMap: { [key: string]: ISelectLabel[] } = {
    IT: [
        { id: "AG", label: "Agrigento", value: "AG",selected:false  },
        { id: "AL", label: "Alessandria", value: "AL",selected:false  },
        { id: "AN", label: "Ancona", value: "AN",selected:false  },
        { id: "AO", label: "Aosta", value: "AO" ,selected:false },
        { id: "AR", label: "Arezzo", value: "AR" ,selected:false },
        { id: "AP", label: "Ascoli Piceno", value: "AP",selected:false  },
        { id: "AT", label: "Asti", value: "AT" ,selected:false },
        { id: "AV", label: "Avellino", value: "AV",selected:false  },
        { id: "BA", label: "Bari", value: "BA",selected:false  },
        { id: "BT", label: "Barletta-Andria-Trani", value: "BT",selected:false  },
        { id: "BL", label: "Belluno", value: "BL" ,selected:false },
        { id: "BN", label: "Benevento", value: "BN",selected:false  },
        { id: "BG", label: "Bergamo", value: "BG" ,selected:false },
        { id: "BI", label: "Biella", value: "BI" ,selected:false },
        { id: "BO", label: "Bologna", value: "BO",selected:false  },
        { id: "BZ", label: "Bolzano", value: "BZ",selected:false  },
        { id: "BS", label: "Brescia", value: "BS" ,selected:false },
        { id: "BR", label: "Brindisi", value: "BR" ,selected:false },
        { id: "CA", label: "Cagliari", value: "CA",selected:false  },
        { id: "CL", label: "Caltanissetta", value: "CL",selected:false  },
        { id: "CB", label: "Campobasso", value: "CB",selected:false  },
        { id: "CE", label: "Caserta", value: "CE",selected:false },
        { id: "CT", label: "Catania", value: "CT" ,selected:false },
        { id: "CZ", label: "Catanzaro", value: "CZ" ,selected:false },
        { id: "CH", label: "Chieti", value: "CH",selected:false  },
        { id: "CO", label: "Como", value: "CO",selected:false  },
        { id: "CS", label: "Cosenza", value: "CS",selected:false  },
        { id: "CR", label: "Cremona", value: "CR",selected:false  },
        { id: "KR", label: "Crotone", value: "KR",selected:false  },
        { id: "CN", label: "Cuneo", value: "CN",selected:false  },
        { id: "EN", label: "Enna", value: "EN" ,selected:false },
        { id: "FM", label: "Fermo", value: "FM" ,selected:false },
        { id: "FE", label: "Ferrara", value: "FE",selected:false  },
        { id: "FI", label: "Firenze", value: "FI",selected:false  },
        { id: "FG", label: "Foggia", value: "FG" ,selected:false },
        { id: "FC", label: "Forlì-Cesena", value: "FC" ,selected:false },
        { id: "FR", label: "Frosinone", value: "FR",selected:false  },
        { id: "GE", label: "Genova", value: "GE" ,selected:false },
        { id: "GO", label: "Gorizia", value: "GO" ,selected:false },
        { id: "GR", label: "Grosseto", value: "GR" ,selected:false },
        { id: "IM", label: "Imperia", value: "IM" ,selected:false },
        { id: "IS", label: "Isernia", value: "IS" ,selected:false },
        { id: "SP", label: "La Spezia", value: "SP",selected:false  },
        { id: "AQ", label: "L'Aquila", value: "AQ",selected:false  },
        { id: "LT", label: "Latina", value: "LT",selected:false  },
        { id: "LE", label: "Lecce", value: "LE" ,selected:false },
        { id: "LC", label: "Lecco", value: "LC" ,selected:false },
        { id: "LI", label: "Livorno", value: "LI",selected:false  },
        { id: "LO", label: "Lodi", value: "LO" ,selected:false },
        { id: "LU", label: "Lucca", value: "LU" ,selected:false },
        { id: "MC", label: "Macerata", value: "MC" ,selected:false },
        { id: "MN", label: "Mantova", value: "MN" ,selected:false },
        { id: "MS", label: "Massa-Carrara", value: "MS" ,selected:false },
        { id: "MT", label: "Matera", value: "MT" ,selected:false },
        { id: "ME", label: "Messina", value: "ME" ,selected:false },
        { id: "MI", label: "Milano", value: "MI" ,selected:false },
        { id: "MO", label: "Modena", value: "MO" ,selected:false },
        { id: "MB", label: "Monza e Brianza", value: "MB" ,selected:false },
        { id: "NA", label: "Napoli", value: "NA",selected:false  },
        { id: "NO", label: "Novara", value: "NO",selected:false  },
        { id: "NU", label: "Nuoro", value: "NU" ,selected:false },
        { id: "OR", label: "Oristano", value: "OR",selected:false  },
        { id: "PD", label: "Padova", value: "PD",selected:false  },
        { id: "PA", label: "Palermo", value: "PA" ,selected:false },
        { id: "PR", label: "Parma", value: "PR" ,selected:false },
        { id: "PV", label: "Pavia", value: "PV" ,selected:false },
        { id: "PG", label: "Perugia", value: "PG" ,selected:false },
        { id: "PU", label: "Pesaro e Urbino", value: "PU",selected:false  },
        { id: "PE", label: "Pescara", value: "PE" ,selected:false },
        { id: "PC", label: "Piacenza", value: "PC" ,selected:false },
        { id: "PI", label: "Pisa", value: "PI" ,selected:false },
        { id: "PT", label: "Pistoia", value: "PT" ,selected:false },
        { id: "PN", label: "Pordenone", value: "PN",selected:false  },
        { id: "PZ", label: "Potenza", value: "PZ" ,selected:false },
        { id: "PO", label: "Prato", value: "PO" ,selected:false },
        { id: "RG", label: "Ragusa", value: "RG" ,selected:false },
        { id: "RA", label: "Ravenna", value: "RA" ,selected:false },
        { id: "RC", label: "Reggio Calabria", value: "RC",selected:false  },
        { id: "RE", label: "Reggio Emilia", value: "RE" ,selected:false },
        { id: "RI", label: "Rieti", value: "RI" ,selected:false },
        { id: "RN", label: "Rimini", value: "RN" ,selected:false },
        { id: "RM", label: "Roma", value: "RM" ,selected:false },
        { id: "RO", label: "Rovigo", value: "RO",selected:false  },
        { id: "SA", label: "Salerno", value: "SA",selected:false  },
        { id: "SS", label: "Sassari", value: "SS",selected:false  },
        { id: "SV", label: "Savona", value: "SV",selected:false  },
        { id: "SI", label: "Siena", value: "SI" ,selected:false },
        { id: "SR", label: "Siracusa", value: "SR" ,selected:false },
        { id: "SO", label: "Sondrio", value: "SO" ,selected:false },
        { id: "SU", label: "Sud Sardegna", value: "SU",selected:false  },
        { id: "TA", label: "Taranto", value: "TA" ,selected:false },
        { id: "TE", label: "Teramo", value: "TE" ,selected:false },
        { id: "TR", label: "Terni", value: "TR" ,selected:false },
        { id: "TO", label: "Torino", value: "TO",selected:false  },
        { id: "TP", label: "Trapani", value: "TP",selected:false  },
        { id: "TN", label: "Trento", value: "TN" ,selected:false },
        { id: "TV", label: "Treviso", value: "TV",selected:false  },
        { id: "TS", label: "Trieste", value: "TS" ,selected:false },
        { id: "UD", label: "Udine", value: "UD" ,selected:false },
        { id: "VA", label: "Varese", value: "VA" ,selected:false },
        { id: "VE", label: "Venezia", value: "VE" ,selected:false },
        { id: "VB", label: "Verbano-Cusio-Ossola", value: "VB" ,selected:false },
        { id: "VC", label: "Vercelli", value: "VC" ,selected:false },
        { id: "VR", label: "Verona", value: "VR" ,selected:false },
        { id: "VV", label: "Vibo Valentia", value: "VV",selected:false  },
        { id: "VI", label: "Vicenza", value: "VI" ,selected:false },
        { id: "VT", label: "Viterbo", value: "VT",selected:false  }
    ],
    default: [
        { id: "EE", label: "EE", value: "EE",selected:false  }, // Opzione per paesi non IT
    ],
};

export const docTypeEN:ISelectLabel[]= [
    { id: "identityCard", label: "Identity Card", value: "identityCard",selected:false  },
    { id: "driveLicense", label: "Driver Licence", value: "driveLicense",selected:false  }
]
export const docType:ISelectLabel[]= [
    { id: "identityCard", label: "Carta di identità", value: "identityCard",selected:false  },
    { id: "driveLicense", label: "Patente di guida", value: "driveLicense",selected:false  }
]
export const states: ISelectLabel[] = myStatesArray.map(code => ({
    id: code,
    label: code,
    value: code
}));